export const getBranchName = (fullBranchName?: string): string | undefined => {
  // full branch name starts with "refs/heads/", so trim that for the url
  if (fullBranchName?.startsWith("refs/heads/"))
    return fullBranchName?.slice(11);
  return fullBranchName;
};
